import { API } from "../api";

export const memberReferralApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getMemberReferralLink: builder.query({
      query: () => "/members/referrals/link?guard=member",
      transformResponse: (responseData) => responseData?.data,
      providesTags: [{ type: "MemberReferral", id: "LINK" }],
    }),
    getMemberReferralFriends: builder.query({
      query: () => "/members/referrals/friends?guard=member",
      transformResponse: (responseData) => responseData?.data,
      providesTags: [{ type: "MemberReferral", id: "FRIENDS" }],
    }),
    sendMemberReferralInvite: builder.mutation({
      query: (body) => ({
        url: "/members/referrals/invite?guard=member",
        method: "POST",
        body: body || {},
      }),
      transformResponse: (responseData) => responseData?.data,
      invalidatesTags: [{ type: "MemberReferral", id: "FRIENDS" }],
    }),
  }),
});

export const {
  useGetMemberReferralLinkQuery,
  useGetMemberReferralFriendsQuery,
  useSendMemberReferralInviteMutation,
} = memberReferralApi;
